import { render, staticRenderFns } from "./TaxReturnArrendamiento.vue?vue&type=template&id=77f7eebc&scoped=true"
import script from "./TaxReturnArrendamiento.vue?vue&type=script&lang=js"
export * from "./TaxReturnArrendamiento.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnArrendamiento.vue?vue&type=style&index=0&id=77f7eebc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f7eebc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f7eebc')) {
      api.createRecord('77f7eebc', component.options)
    } else {
      api.reload('77f7eebc', component.options)
    }
    module.hot.accept("./TaxReturnArrendamiento.vue?vue&type=template&id=77f7eebc&scoped=true", function () {
      api.rerender('77f7eebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/TaxReturnArrendamiento.vue"
export default component.exports